import { RootState } from 'store';
import { useSelector } from 'react-redux';

import { STATE } from '../types/state';
import {
  checkIsLoadStatus,
  checkIsDoneStatus,
  checkIsErrorStatus,
} from 'common/utils/loadingStatus';

export const useActiveEvent = () => {
  const result = useSelector(
    (state: RootState) => state[STATE].activeSpecialEvent,
  );

  return result;
};

export const useSpecialEventOnlyForAuthorizedUsers = () => {
  const { onlyForAuthorizedUsers } = useActiveEvent();

  return onlyForAuthorizedUsers;
};

export const useActiveEventLoadingStatus = () => {
  const { isLoading } = useActiveEvent();

  return isLoading;
};

export const useIsActiveEventDone = () => {
  const eventsStatusLoading = useActiveEventLoadingStatus();
  return checkIsDoneStatus(eventsStatusLoading);
};

export const useIsActiveEventLoading = () => {
  const eventsStatusLoading = useActiveEventLoadingStatus();
  return checkIsLoadStatus(eventsStatusLoading);
};

export const useIsActiveEventError = () => {
  const eventsStatusLoading = useActiveEventLoadingStatus();
  return checkIsErrorStatus(eventsStatusLoading);
};
